import React, { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import Message, { MessageProps } from 'carbon-react/lib/components/message';

export interface WizardFormErrorProps extends Omit<MessageProps, 'variant' | 'title'> {
  message?: ReactNode;
}

export const WizardFormError = ({ message, ...props }: WizardFormErrorProps) => {
  const intl = useIntl();

  const standardErrorText = intl.formatMessage({
    id: 'predict.create_forecast.try_again',
    defaultMessage: 'Try again'
  });

  return (
    <Message
      {...props}
      variant="error"
      title={intl.formatMessage({
        id: 'common.something_went_wrong',
        defaultMessage: 'Something went wrong'
      })}
    >
      {message || standardErrorText}
    </Message>
  );
};
